module.exports = __webpack_public_path__ + "img/south_africa.b7f35ee.webp";